import { FC } from "react";
import { ZoneSkipArrivalScanModal } from "./ZoneSkipArrivalScanModal";
import { ZoneSkipArrivalScanErrorModal, ZoneSkipArrivalScanErrorModalProps } from "./ZoneSkipArrivalScanErrorModal";

export const zoneSkipArrivalScanModalMap: Record<ZoneSkipArrivalScanModal, FC<any>> = {
  [ZoneSkipArrivalScanModal.GAYLORD_NOT_FOUND]: ZoneSkipArrivalScanErrorModal,
  [ZoneSkipArrivalScanModal.GAYLORD_NOT_ELIGIBLE]: ZoneSkipArrivalScanErrorModal,
  [ZoneSkipArrivalScanModal.GAYLORD_NOT_ELIGIBLE_FOR_ARRIVAL_SCAN]: ZoneSkipArrivalScanErrorModal,
  [ZoneSkipArrivalScanModal.UNKNOWN_ERROR]: ZoneSkipArrivalScanErrorModal,
};

export const zoneSkipArrivalScanMessageMap: Record<ZoneSkipArrivalScanModal, ZoneSkipArrivalScanErrorModalProps> = {
  [ZoneSkipArrivalScanModal.GAYLORD_NOT_FOUND]: {
    title: "Gaylord not found",
    text: "The gaylord scanned is not valid. Please check the barcode and try again.",
    hideModalValue: ZoneSkipArrivalScanModal.GAYLORD_NOT_FOUND,
  },
  [ZoneSkipArrivalScanModal.GAYLORD_NOT_ELIGIBLE]: {
    title: "Gaylord not eligible for transfer",
    text: "This Gaylord is not pre-sorted for this sort center.",
    hideModalValue: ZoneSkipArrivalScanModal.GAYLORD_NOT_ELIGIBLE,
  },
  [ZoneSkipArrivalScanModal.GAYLORD_NOT_ELIGIBLE_FOR_ARRIVAL_SCAN]: {
    title: "Gaylord not eligible for arrival scan",
    text: "This Gaylord is not eligible for arrival scan at this sort center.",
    hideModalValue: ZoneSkipArrivalScanModal.GAYLORD_NOT_ELIGIBLE_FOR_ARRIVAL_SCAN,
  },
  [ZoneSkipArrivalScanModal.UNKNOWN_ERROR]: {
    title: "Unknown error",
    text: "An unknown error occurred. Please try again. Contact a supervisor if the issue persists.",
    hideModalValue: ZoneSkipArrivalScanModal.UNKNOWN_ERROR,
  },
};
